import { PostLoadingController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher } from "@quest/base-core";

export class PostLoadingControllerGame extends PostLoadingController {
  constructor(json: any) {
    super(json);
    this.view.visible = false;
  }

  /**
   * Method overrided
   */
  protected subscribEvents(): void {
    super.subscribEvents();
    dispatcher.on(eventDispatchers.SHOW_POSTLOADING_VIEW, this.showPostLoadingView, this);
  }

  /**
   * Method overrided
   */
  protected unsubscribEvents(): void {
    super.unsubscribEvents();
    dispatcher.off(eventDispatchers.SHOW_POSTLOADING_VIEW, this.showPostLoadingView, this);
  }

  // Add to show view
  private showPostLoadingView(): void {
    this.view.visible = true;
  }
}
